import type { Currency_Schema } from "@/services/currencies/currenciesSchema";
import type { z } from "zod";

export enum CurrencyId {
  Czk = 1,
  Eur = 2,
  Gbp = 3,
  Usd = 4,
}
export const FallbackCurrencyId = CurrencyId.Czk;

export type Currency = z.infer<typeof Currency_Schema>;
